import CoreuiController from "../lib/coreui-controller"
import TimePicker from "../coreui/time-picker"

export default class CoreuiTimePickerController extends CoreuiController {
  static Component = TimePicker
}
